<template>
    <div>
      <ion-toolbar>
        <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
          <ion-button class="button_back" @click="goBack">
            <ion-icon name="arrow-back-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button @click="skip" class="pill next-pill-button">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
      </ion-toolbar>
  
      <div class="main_wrapper ion-padding">
        <div class="container">
          <div class="auth-header">
                <div class="auth-heading">
                    <h1>Travel Preferences</h1>
                </div>
                <div class="brand-icon" >
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                </div>
            </div>
          <el-form
              :model="formsData.userForm"
              :rules="formsData.userForm.rules"
              :ref="(el) => (formsData.userForm.ref = el)"
              :label-position="'top'"
              @submit.prevent="save('userForm')"
              @keyup.enter="save('userForm')"
              class="full_page"
          >
            <div class="form_text mt-3">
              <div class="text text-standout">
                Are you willing to take on an assignment for a temporary period of time (1 - 13 weeks) where accommodation and travel costs are covered?
              </div>
            </div>
            <!-- <div class="description">
                <strong>Yes:</strong>
                <div>Locumate will create an invoice on your behalf.
                    We will also provide a yerly summary to make things
                    easy for you and your accountant.</div>
            </div>
            <div class="description">
                <strong>No:</strong>
                <div>In order to create invoices on your behalf
                    (Recepient Tax Invoice), you will need to be
                    registered for travel_assignment.<a href="#">Register here</a></div>
            </div>
            <div class="note">
                You can still sign up to Locumate without being
                registered for travel_assignment, however, you will need to
                manually create an invoice. We will send you the required details.
            </div> -->
            <el-form-item class="button_submit mb0">
                <el-button class="submit" type="blue_light" @click="setTravel(0)">
                    No
                </el-button>
                <el-button class="submit" type="blue" @click="setTravel(1)">
                    Yes
                </el-button>
            </el-form-item>
            <!-- <el-form-item prop="travel_assignment">
              <el-radio-group v-model="formsData.userForm.travel_assignment.value">
                <el-radio-button v-for="item in formsData.userForm.travel_assignment.data" :key="item.value" :label="item.value">
                  {{ item.label }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item> -->
            <!-- <el-form-item class="button_submit mb0">
              <el-button   class="submit" type="blue" @click="save('userForm')">
                <span>Continue <i class="el-icon-right"></i></span>
              </el-button>
            </el-form-item> -->
          </el-form>
          <div class="background-circles">
              <div class="circle circle-2"></div>
              <div class="circle circle-1"></div>
              <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  
  import {
    onMounted,
    inject,
  } from "vue";
  
  import {addIcons} from "ionicons";
  import {arrowBackOutline} from "ionicons/icons";
  
  
  
  addIcons({
    "arrow-back-outline": arrowBackOutline,
  });
  import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
  } from "@ionic/vue";
  
  import {useStore} from "vuex";
  import {
    useRouter,
    useRoute,
  
  } from "vue-router";
  import formHooks from "@/hooks/form/form";
  
  import isEmpty from "lodash/isEmpty";
  import { ElMessageBox } from "@/components/Vendor/Element";
  import SvgIcon from '@/components/Svg/SvgIcon.vue';
  
  export default {
    components: {
      IonToolbar,
      IonButton,
      IonButtons,
      IonIcon,
      SvgIcon,
    },
  
    setup() {
      const $store = useStore();
      const $router = useRouter();
      const $route = useRoute()
      const setPageClassGlobal = inject(["setPageClassGlobal"]);
      const routeName = $route.name;
  
      const userData = $store.getters.GET_USER_DATA;
      const userRole = userData.role;
  
      const formsDataArray = {
        userForm: {
          travel_assignment: {
            data: [{value: '0', label: 'No'}, {value: '1', label: 'Yes'}],
            value: userData.travel_assignment ? userData.travel_assignment :  0,
          },
        },
      };
      const goNext = () => {
        if (routeName === 'profile_travel_assignment') {
          $router.push({
            name: 'profile'
          })
        } else{
          $router.push({
            name: 'covid_status',
            // name: 'auth_travel',
          })
        }
      };
      const goBack = async() => {
        if (routeName === 'profile_travel_assignment') {
          $router.push({
            name: 'profile_edit'
          })
        } else {
          const back = await $store.dispatch("getAuthPageBack");
          $router.push({
              name: back,
          });  
        }
      };
      const setTravel = (value) => {
        formsData.userForm.travel_assignment.value = value
        save('userForm')
      };
      const save = (formName) => {
        formsRefs[formName].value.validate((valid) => {
          if (valid) {
              try {
                const data = getFormValues(formName);
                if(isEmpty(data) ) {
                  const payload = {travel_assignment : 0}
                  $store.dispatch("SAVE_USER_DATA", payload)
                } else {
                  $store.dispatch("SAVE_USER_DATA", data)
                }
                goNext()
              } catch (errors) {
                checkFormValidation(formName, true);
              }
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      };

      const skip = () => {
            (async () => {
                try {
                    await ElMessageBox.confirm(
                        ``,
                        "Do you want to skip? You will be unverified",
                        {
                            distinguishCancelAndClose: true,
                            showConfirmButton: true,
                            confirmButtonText: "Skip",
                            cancelButtonText: "Cancel",
                            confirmButtonClass: "el-button--green",
                            cancelButtonClass: "el-button--grey",
                            showClose: true,
                        }
                    );
                } catch {
                    return;
                }
                try {
                  $store.dispatch('addAuthPageBack', $route.name);
                  goNext()
                } catch (error) {
                    console.log(error);
                }
            })();
          
        }
      onMounted(() => {
        setPageClassGlobal('global_auth_page');
        setFormRefs();
      });
  
      const {
        checkFormValidation,
  
        getFormValues,
        setFormRefs,
        formsData,
        formsRefs,
      } = formHooks(formsDataArray);
      
  
  
  
      return {
        setTravel,
        formsData,
        checkFormValidation,
        goBack,
        save,
        userData,
        userRole,
        routeName,
        skip
      };
    },
  };
  </script>
  